export const allowedRcsExtensions = ['jpg', 'jpeg', 'png', 'gif', 'mp4', 'mp3', 'pdf']
export const allowedRcsMimeTypes = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'video/mp4',
  'audio/mpeg',
  'audio/mp3',
  'application/pdf',
]

export const allowedRcsExtensionsFiltered = allowedRcsExtensions.filter(
  (extension) => !(extension === 'jpeg' && allowedRcsExtensions.includes('jpg'))
)
